import { useState } from "react";
import { fileUrl } from "@/lib/api";
import { eurOr, REASONS } from "@/lib/wh";

const INFO = [["category", "Categoria"], ["subcategory", "Sottocategoria"], ["color", "Colore"], ["brand", "Marca"], ["model", "Modello"],
  ["condition", "Condizioni"], ["location", "Posizione"], ["defects", "Difetti"], ["notes", "Note interne"]];
const reasonLabel = Object.fromEntries(REASONS);

export function ItemPhotos({ photos }) {
  const [i, setI] = useState(0);
  if (!photos?.length) return <div className="rounded-2xl border border-dashed h-56 grid place-items-center text-sm text-[var(--muted)]" data-testid="wh-no-photo">Nessuna foto</div>;
  return (
    <div className="space-y-2" data-testid="wh-item-photos">
      <img src={fileUrl(photos[i] || photos[0])} alt="Articolo" className="w-full max-h-[420px] object-contain rounded-2xl border bg-[var(--surface-2)]" />
      {photos.length > 1 && (
        <div className="flex gap-2 overflow-x-auto">
          {photos.map((p, k) => <button key={p} onClick={() => setI(k)} className={`shrink-0 rounded-lg border-2 ${k === i ? "border-[var(--primary)]" : "border-transparent"}`}><img src={fileUrl(p)} alt="" className="h-16 w-16 object-cover rounded-md" /></button>)}
        </div>
      )}
    </div>
  );
}

export function ItemInfo({ it }) {
  const money = [["Prezzo di vendita", it.sale_price], ...(it.purchase_price !== undefined ? [["Prezzo di acquisto", it.purchase_price], ["Costi aggiuntivi", it.extra_costs]] : []), ["Incassato", it.revenue]];
  return (
    <div className="rounded-2xl bg-white border border-[var(--border)] p-5 space-y-4" data-testid="wh-item-info">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-center">
        {[["Totale", it.quantity], ["Disponibili", it.qty_available], ["Venduti", it.qty_sold], ["Rimossi", it.qty_removed]].map(([l, v]) => (
          <div key={l} className="rounded-xl bg-[var(--surface-2)] p-2"><p className="text-[11px] uppercase text-[var(--muted)]">{l}</p><p className="font-heading text-xl font-bold" data-testid={`wh-qty-${l.toLowerCase()}`}>{v}</p></div>
        ))}
      </div>
      <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
        {money.map(([l, v]) => <div key={l} className="flex justify-between border-b border-dashed py-1"><dt className="text-[var(--muted)]">{l}</dt><dd className="font-mono">{eurOr(v)}</dd></div>)}
        {INFO.filter(([k]) => it[k]).map(([k, l]) => <div key={k} className="flex justify-between gap-3 border-b border-dashed py-1"><dt className="text-[var(--muted)]">{l}</dt><dd className="text-right break-words min-w-0">{it[k]}</dd></div>)}
        <div className="flex justify-between border-b border-dashed py-1"><dt className="text-[var(--muted)]">Inserito</dt><dd>{new Date(it.created_at).toLocaleString("it-IT")} · {it.created_by}</dd></div>
      </dl>
    </div>
  );
}

export function ItemOps({ it, canRestore, onRestore }) {
  const ops = [...(it.sales || []).map((s) => ({ ...s, kind: "sales" })), ...(it.removals || []).map((r) => ({ ...r, kind: "removals" }))].sort((a, b) => b.at.localeCompare(a.at));
  if (!ops.length) return null;
  return (
    <div className="rounded-2xl bg-white border border-[var(--border)] p-5 space-y-2" data-testid="wh-item-ops">
      <h3 className="font-semibold">Vendite e rimozioni</h3>
      {ops.map((o) => (
        <div key={o.id} className="flex items-center justify-between gap-3 text-sm py-1 border-b border-dashed" data-testid={`wh-op-${o.id}`}>
          <span>{o.kind === "sales" ? `Venduto ${o.qty} pz · ${eurOr(o.price)}` : `Rimosso ${o.qty} pz · ${reasonLabel[o.reason] || o.reason}${o.note ? ` – ${o.note}` : ""}`}
            <span className="block text-xs text-[var(--muted)]">{new Date(o.at).toLocaleString("it-IT")} · {o.by}</span></span>
          {canRestore && <button onClick={() => onRestore(o)} className="btn-secondary h-8 px-3 text-xs" data-testid={`wh-restore-${o.id}`}>Annulla</button>}
        </div>
      ))}
    </div>
  );
}
